import ModeButton from '../ModeButton'
import ModeButtons from '../ModeButtons'
import AnalyticsButton from '../AnalyticsButton'
import React, { FC } from 'react'
import { VIEW_STATE_POOLS, VIEW_STATE_TRADE } from '../../pages/App'
import styled from 'styled-components'
import { createEarnTabEvent, createTradeTabEvent } from 'user-events-segment'

interface Props {
  page: any
}

export const HeaderTabs: FC<Props> = ({ page }) => {
  return (
    <Wrapper>
      <ModeButtons>
        <ModeButton
          to={'/pools'}
          $isActivated={isViewPools(page)}
          data-cy={'invest-switch'}
        >
          <span onClick={() => createEarnTabEvent().clicked_earn_tab()}>
            Earn
          </span>
        </ModeButton>
        <ModeButton
          to={'/swap'}
          $isActivated={page === VIEW_STATE_TRADE}
          data-cy={'trade-switch'}
        >
          <span onClick={() => createTradeTabEvent().clicked_trade_tab()}>
            Trade
          </span>
        </ModeButton>
      </ModeButtons>
      <AnalyticsButton
        href={'https://dune.com/swaaplabs/swaap'}
        target="_blank"
      >
        Analytics
        <sup style={{ fontFamily: 'Montserrat' }}>↗</sup>
      </AnalyticsButton>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  padding: 0.5rem;
  box-shadow: ${({ theme }) => theme.modeButtonsShadow};
  font-size: 2.3rem;
  justify-content: center;
  align-items: center;
`

export default ModeButtons

function isViewPools(pageNumber: number) {
  return pageNumber !== VIEW_STATE_TRADE
}

export function isViewTrade(): boolean {
  const url = window.location.href
  return !!(url && url.includes('#/swap'))
}
